import { useLocation } from 'react-router';
import { HpiEligibilityFlow } from 'src/shared/models/shared';
/**
 * This hook retuns the HpiEligibilityFlow based on
 * the state if it doesn't exist then gets it from search params
 * if none of all returns therapy as default
 * @returns HpiEligibilityFlow
 */
export const useHpiEligibilityFlow = () => {
    const location = useLocation<{ hpiEligibilityFlow?: HpiEligibilityFlow }>();
    const searchParams = new URLSearchParams(location?.search);
    const hpiEligibilityFlow =
        location?.state?.hpiEligibilityFlow ||
        (searchParams.get('hpiEligibilityFlow') as HpiEligibilityFlow);
    return hpiEligibilityFlow ?? HpiEligibilityFlow.Therapy;
};
